module.exports = __webpack_public_path__ + "img/ExitusMujer-BocetoCalle@2x.a72714f0.png";